export default __webpack_public_path__ + "static/media/S0020_6.8_JDM.1702919160000.c667fddc.jpg";